function observables() {
	let observables = document.querySelectorAll('[data-observable]');
	let observer    = new IntersectionObserver( ( entries ) => {
		entries.forEach( entry => {
			if( entry.isIntersecting ) {
				entry.target.dataset.observed = true;

				observer.unobserve( entry.target );
			}
		});
	}, {
		rootMargin: '0px 0px -5% 0px',
		threshold: 1
	});
	
	observables.forEach( observable => {
		observer.observe( observable );
	});
}

export {observables};